import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../Api/api';
import {
  REQUEST_GET_ALL_PROJECTS_FOR_ADMIN,
  SUCCESS_GET_ALL_PROJECTS_FOR_ADMIN,
  FAIL_GET_ALL_PROJECTS_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_FOR_ADMIN,
  FAIL_GET_ALL_USERS_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  FAIL_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
  FAIL_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
  REQUEST_GET_PROJECT_DATA,
  SUCCESS_GET_PROJECT_DATA,
  FAIL_GET_PROJECT_DATA,
  REQUEST_DELETE_USER_FROM_STAGE,
  SUCCESS_DELETE_USER_FROM_STAGE,
  FAIL_DELETE_USER_FROM_STAGE,
  REQUEST_DELETE_SELF_USER_FROM_STAGE,
  SUCCESS_DELETE_SELF_USER_FROM_STAGE,
  FAIL_DELETE_SELF_USER_FROM_STAGE,
  REQUEST_ADD_USER_TO_STAGE,
  SUCCESS_ADD_USER_TO_STAGE,
  FAIL_ADD_USER_TO_STAGE,
  REQUEST_ADD_SELF_USER_TO_STAGE,
  SUCCESS_ADD_SELF_USER_TO_STAGE,
  FAIL_ADD_SELF_USER_TO_STAGE,
  REQUEST_GET_USER_DATA_FOR_ADMIN,
  SUCCESS_GET_USER_DATA_FOR_ADMIN,
  FAIL_GET_USER_DATA_FOR_ADMIN,
  REQUEST_GET_USER_DATA_FOR_SELF,
  SUCCESS_GET_USER_DATA_FOR_SELF,
  FAIL_GET_USER_DATA_FOR_SELF,
  REQUEST_GET_AUTH_USER_DATA,
  SUCCESS_GET_AUTH_USER_DATA,
  FAIL_GET_AUTH_USER_DATA,
  REQUEST_GET_USER_ACTIVE_PROJECT_TREE_DATA,
  SUCCESS_GET_USER_ACTIVE_PROJECT_TREE_DATA,
  FAIL_GET_USER_ACTIVE_PROJECT_TREE_DATA,
  REQUEST_GET_USER_INACTIVE_PROJECT_TREE_DATA,
  SUCCESS_GET_USER_INACTIVE_PROJECT_TREE_DATA,
  FAIL_GET_USER_INACTIVE_PROJECT_TREE_DATA,
  REQUEST_GET_TIME_SHEET_DATA,
  SUCCESS_GET_TIME_SHEET_DATA,
  FAIL_GET_TIME_SHEET_DATA,
  REQUEST_GET_TIME_SHEET_DATA_OF_USER,
  SUCCESS_GET_TIME_SHEET_DATA_OF_USER,
  FAIL_GET_TIME_SHEET_DATA_OF_USER,
  REQUEST_GET_ALL_INCOME_EXPENSE,
  SUCCESS_GET_ALL_INCOME_EXPENSE,
  FAIL_GET_ALL_INCOME_EXPENSE,
  REQUEST_DELETE_INCOME_EXPENSE_ENTRY,
  SUCCESS_DELETE_INCOME_EXPENSE_ENTRY,
  FAIL_DELETE_INCOME_EXPENSE_ENTRY,
  SUCCESS_ADD_INCOME_EXPENSE_ENTRY,
  FAIL_ADD_INCOME_EXPENSE_ENTRY,
  REQUEST_ADD_INCOME_EXPENSE_ENTRY,
  REQUEST_GET_INCOME_EXPENSE_BALANCE,
  SUCCESS_GET_INCOME_EXPENSE_BALANCE,
  FAIL_GET_INCOME_EXPENSE_BALANCE,
  REQUEST_GET_CALENDAR_DATA,
  SUCCESS_GET_CALENDAR_DATA,
  FAIL_GET_CALENDAR_DATA,
  REQUEST_GET_ALL_ACTIVITIES,
  SUCCESS_GET_ALL_ACTIVITIES,
  FAIL_GET_ALL_ACTIVITIES,
  REQUEST_GET_ACTIVITY_DATA,
  SUCCESS_GET_ACTIVITY_DATA,
  FAIL_GET_ACTIVITY_DATA,
  REQUEST_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
  FAIL_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
  FAIL_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
  REQUEST_DELETE_USER_FROM_ACTIVITY,
  SUCCESS_DELETE_USER_FROM_ACTIVITY,
  FAIL_DELETE_USER_FROM_ACTIVITY,
  REQUEST_ADD_USER_TO_ACTIVITY,
  SUCCESS_ADD_USER_TO_ACTIVITY,
  FAIL_ADD_USER_TO_ACTIVITY,
  REQUEST_GET_USER_ACTIVITIES_DATA,
  SUCCESS_GET_USER_ACTIVITIES_DATA,
  FAIL_GET_USER_ACTIVITIES_DATA,
  REQUEST_GET_HOLIDAY_INFO,
  SUCCESS_GET_HOLIDAY_INFO,
  FAIL_GET_HOLIDAY_INFO,
  REQUEST_GET_SELF_STATS,
  SUCCESS_GET_SELF_STATS,
  FAIL_GET_SELF_STATS,
  REQUEST_GET_All_USERS_STATS,
  SUCCESS_GET_All_USERS_STATS,
  FAIL_GET_All_USERS_STATS,
  REQUEST_GET_SELF_CLAIMS,
  SUCCESS_GET_SELF_CLAIMS,
  FAIL_GET_SELF_CLAIMS,
  REQUEST_GET_USER_CLAIMS,
  SUCCESS_GET_USER_CLAIMS,
  FAIL_GET_USER_CLAIMS,
  LOADING_GET_STAGE_STATS,
  REQUEST_GET_STAGE_STATS,
  SUCCESS_GET_STAGE_STATS,
  FAIL_GET_STAGE_STATS,
  LOADING_GET_PROJECT_STATS,
  REQUEST_GET_PROJECT_STATS,
  SUCCESS_GET_PROJECT_STATS,
  FAIL_GET_PROJECT_STATS,
  LOADING_GET_ACTIVITY_STATS,
  REQUEST_GET_ACTIVITY_STATS,
  SUCCESS_GET_ACTIVITY_STATS,
  FAIL_GET_ACTIVITY_STATS,
} from '../constants/constants';

function* fetchProjects() {
  try {
    const response = yield call(api.getAllProjectsForAdmin);
    yield put({ type: SUCCESS_GET_ALL_PROJECTS_FOR_ADMIN, response });
  } catch (e) {
    yield put({ type: FAIL_GET_ALL_PROJECTS_FOR_ADMIN, message: e.message });
  }
}
function* watchFetchProjects() {
  yield takeLatest(REQUEST_GET_ALL_PROJECTS_FOR_ADMIN, fetchProjects);
}

function* fetchUsers() {
  try {
    const response = yield call(api.getAllUsersForAdmin);
    yield put({ type: SUCCESS_GET_ALL_USERS_FOR_ADMIN, response });
  } catch (e) {
    yield put({ type: FAIL_GET_ALL_USERS_FOR_ADMIN, message: e.message });
  }
}
function* watchFetchUsers() {
  yield takeLatest(REQUEST_GET_ALL_USERS_FOR_ADMIN, fetchUsers);
}

function* fetchUsersForStage(action) {
  try {
    const response = yield call(api.getAllUsersInStageForAdmin, action.payload);
    yield put({ type: SUCCESS_GET_ALL_USERS_IN_STAGE_FOR_ADMIN, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
      message: e.message,
    });
  }
}
function* watchFetchUsersForStage() {
  yield takeLatest(
    REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
    fetchUsersForStage
  );
}

function* fetchUsersNotForStage(action) {
  try {
    const response = yield call(
      api.getAllUsersNotInStageForAdmin,
      action.payload
    );
    yield put({ type: SUCCESS_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
      message: e.message,
    });
  }
}
function* watchFetchNotUsersForStage() {
  yield takeLatest(
    REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
    fetchUsersNotForStage
  );
}

function* fetchProjectData(action) {
  try {
    const response = yield call(api.getAllProjectData, action.payload);
    yield put({ type: SUCCESS_GET_PROJECT_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_PROJECT_DATA,
      message: e.message,
    });
  }
}
function* watchFetchProjectData() {
  yield takeLatest(REQUEST_GET_PROJECT_DATA, fetchProjectData);
}

function* deleteUserFromStage(action) {
  try {
    const response = yield call(api.deleteUserFromStage, action.payload);
    yield put({ type: SUCCESS_DELETE_USER_FROM_STAGE, response });
    yield call(fetchUsersForStage, { payload: action.payload.stageId });
    yield call(fetchUsersNotForStage, { payload: action.payload.stageId });
  } catch (e) {
    yield put({
      type: FAIL_DELETE_USER_FROM_STAGE,
      message: e.message,
    });
  }
}
function* watchDeleteUserFromStage() {
  yield takeLatest(REQUEST_DELETE_USER_FROM_STAGE, deleteUserFromStage);
}

function* deleteSelfUserFromStage(action) {
  try {
    const response = yield call(api.deleteSelfUserFromStage, action.payload);
    yield put({ type: SUCCESS_DELETE_SELF_USER_FROM_STAGE, response });
    yield call(fetchUsersForStage, { payload: action.payload.stageId });
    yield call(fetchUsersNotForStage, { payload: action.payload.stageId });
  } catch (e) {
    yield put({
      type: FAIL_DELETE_SELF_USER_FROM_STAGE,
      message: e.message,
    });
  }
}
function* watchDeleteSelfUserFromStage() {
  yield takeLatest(
    REQUEST_DELETE_SELF_USER_FROM_STAGE,
    deleteSelfUserFromStage
  );
}

function* addUserToStage(action) {
  try {
    const response = yield call(api.addUserToStage, action.payload);
    yield put({ type: SUCCESS_ADD_USER_TO_STAGE, response });
    yield call(fetchUsersForStage, { payload: action.payload.stageId });
    yield call(fetchUsersNotForStage, { payload: action.payload.stageId });
  } catch (e) {
    yield put({
      type: FAIL_ADD_USER_TO_STAGE,
      message: e.message,
    });
  }
}
function* watchAddUserToStage() {
  yield takeLatest(REQUEST_ADD_USER_TO_STAGE, addUserToStage);
}

function* addSelfUserToStage(action) {
  try {
    const response = yield call(api.addSelfUserToStage, action.payload);
    yield put({ type: SUCCESS_ADD_SELF_USER_TO_STAGE, response });
    yield call(fetchUsersForStage, { payload: action.payload.stageId });
    yield call(fetchUsersNotForStage, { payload: action.payload.stageId });
  } catch (e) {
    yield put({
      type: FAIL_ADD_SELF_USER_TO_STAGE,
      message: e.message,
    });
  }
}
function* watchAddSelfUserToStage() {
  yield takeLatest(REQUEST_ADD_SELF_USER_TO_STAGE, addSelfUserToStage);
}

function* fetchUserDataForAdmin(action) {
  try {
    const response = yield call(api.getAllUserDataForAdmin, action.payload);
    yield put({ type: SUCCESS_GET_USER_DATA_FOR_ADMIN, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_USER_DATA_FOR_ADMIN,
      message: e.message,
    });
  }
}
function* watchFetchUserDataForAdmin() {
  yield takeLatest(REQUEST_GET_USER_DATA_FOR_ADMIN, fetchUserDataForAdmin);
}

function* fetchUserDataForSelf() {
  try {
    const response = yield call(api.getAllUserDataForSelf);
    yield put({ type: SUCCESS_GET_USER_DATA_FOR_SELF, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_USER_DATA_FOR_SELF,
      message: e.message,
    });
  }
}
function* watchFetchUserDataForSelf() {
  yield takeLatest(REQUEST_GET_USER_DATA_FOR_SELF, fetchUserDataForSelf);
}

function* fetchAuthUserData(action) {
  try {
    const response = yield call(api.getAuthUserData, action.payload);
    yield put({ type: SUCCESS_GET_AUTH_USER_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_AUTH_USER_DATA,
      message: e.message,
    });
  }
}
function* watchFetchAuthUserData() {
  yield takeLatest(REQUEST_GET_AUTH_USER_DATA, fetchAuthUserData);
}

function* fetchUserActiveProjectTreeData(action) {
  try {
    const response = yield call(api.getUserProjectTreeData, action.payload);
    yield put({ type: SUCCESS_GET_USER_ACTIVE_PROJECT_TREE_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_USER_ACTIVE_PROJECT_TREE_DATA,
      message: e.message,
    });
  }
}
function* watchFetchUserActiveProjectTreeData() {
  yield takeLatest(
    REQUEST_GET_USER_ACTIVE_PROJECT_TREE_DATA,
    fetchUserActiveProjectTreeData
  );
}

function* fetchUserInactiveProjectTreeData(action) {
  try {
    const response = yield call(api.getUserProjectTreeData, action.payload);
    yield put({ type: SUCCESS_GET_USER_INACTIVE_PROJECT_TREE_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_USER_INACTIVE_PROJECT_TREE_DATA,
      message: e.message,
    });
  }
}
function* watchFetchUserInactiveProjectTreeData() {
  yield takeLatest(
    REQUEST_GET_USER_INACTIVE_PROJECT_TREE_DATA,
    fetchUserInactiveProjectTreeData
  );
}

function* fetchGetTimeSheetData(action) {
  try {
    const response = yield call(api.getTimeSheetData, action.payload);
    yield put({ type: SUCCESS_GET_TIME_SHEET_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_TIME_SHEET_DATA,
      message: e.message,
    });
  }
}
function* watchFetchGetTimeSheetData() {
  yield takeLatest(REQUEST_GET_TIME_SHEET_DATA, fetchGetTimeSheetData);
}

function* fetchGetTimeSheetDataOfUser(action) {
  try {
    const response = yield call(api.getTimeSheetDataOfUser, action.payload);
    yield put({ type: SUCCESS_GET_TIME_SHEET_DATA_OF_USER, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_TIME_SHEET_DATA_OF_USER,
      message: e.message,
    });
  }
}
function* watchFetchGetTimeSheetDataOfUser() {
  yield takeLatest(
    REQUEST_GET_TIME_SHEET_DATA_OF_USER,
    fetchGetTimeSheetDataOfUser
  );
}

function* getAllIncomeExpense(action) {
  try {
    const response = yield call(api.getAllIncomeExpense, action.payload);
    yield put({ type: SUCCESS_GET_ALL_INCOME_EXPENSE, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ALL_INCOME_EXPENSE,
      message: e.message,
    });
  }
}
function* watchGetAllIncomeExpense() {
  yield takeLatest(REQUEST_GET_ALL_INCOME_EXPENSE, getAllIncomeExpense);
}

function* deleteIncomeExpenseEntry(action) {
  try {
    const response = yield call(api.deleteIncomeExpenseEntry, {
      entryId: action.payload.entryId,
    });
    yield put({ type: SUCCESS_DELETE_INCOME_EXPENSE_ENTRY, response });
    yield call(getAllIncomeExpense, { payload: action.payload.stageId });
    yield call(getIncomeExpenseBalance, { payload: action.payload.stageId });
  } catch (e) {
    yield put({
      type: FAIL_DELETE_INCOME_EXPENSE_ENTRY,
      message: e.message,
    });
  }
}
function* watchDeleteIncomeExpenseEntry() {
  yield takeLatest(
    REQUEST_DELETE_INCOME_EXPENSE_ENTRY,
    deleteIncomeExpenseEntry
  );
}

function* addIncomeExpenseEntry(action) {
  try {
    const response = yield call(api.addIncomeExpenseEntry, action.payload);
    yield put({ type: SUCCESS_ADD_INCOME_EXPENSE_ENTRY, response });
    yield call(getAllIncomeExpense, { payload: action.payload.stageId });
    yield call(getIncomeExpenseBalance, { payload: action.payload.stageId });
  } catch (e) {
    yield put({
      type: FAIL_ADD_INCOME_EXPENSE_ENTRY,
      message: e.message,
    });
  }
}
function* watchAddIncomeExpenseEntry() {
  yield takeLatest(REQUEST_ADD_INCOME_EXPENSE_ENTRY, addIncomeExpenseEntry);
}

function* getIncomeExpenseBalance(action) {
  try {
    const response = yield call(api.getIncomeExpenseBalance, action.payload);
    yield put({ type: SUCCESS_GET_INCOME_EXPENSE_BALANCE, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_INCOME_EXPENSE_BALANCE,
      message: e.message,
    });
  }
}
function* watchGetIncomeExpenseBalance() {
  yield takeLatest(REQUEST_GET_INCOME_EXPENSE_BALANCE, getIncomeExpenseBalance);
}

function* getCalendarData(action) {
  try {
    const response = yield call(api.getCalendarData, action.payload);
    yield put({ type: SUCCESS_GET_CALENDAR_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_CALENDAR_DATA,
      message: e.message,
    });
  }
}
function* watchGetCalendarData() {
  yield takeLatest(REQUEST_GET_CALENDAR_DATA, getCalendarData);
}

function* getAllActivities() {
  try {
    const response = yield call(api.getAllActivities);
    yield put({ type: SUCCESS_GET_ALL_ACTIVITIES, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ALL_ACTIVITIES,
      message: e.message,
    });
  }
}
function* watchGetAllActivities() {
  yield takeLatest(REQUEST_GET_ALL_ACTIVITIES, getAllActivities);
}

function* getAllActivityData(action) {
  try {
    const response = yield call(api.getAllActivityData, action.payload);
    yield put({ type: SUCCESS_GET_ACTIVITY_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ACTIVITY_DATA,
      message: e.message,
    });
  }
}
function* watchGetAllActivityData() {
  yield takeLatest(REQUEST_GET_ACTIVITY_DATA, getAllActivityData);
}

function* fetchUsersForActivity(action) {
  try {
    const response = yield call(
      api.getAllUsersInActivityForAdmin,
      action.payload
    );
    yield put({ type: SUCCESS_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
      message: e.message,
    });
  }
}
function* watchFetchUsersForActivity() {
  yield takeLatest(
    REQUEST_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
    fetchUsersForActivity
  );
}

function* fetchUsersNotForActivity(action) {
  try {
    const response = yield call(
      api.getAllUsersNotInActivityForAdmin,
      action.payload
    );
    yield put({
      type: SUCCESS_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
      response,
    });
  } catch (e) {
    yield put({
      type: FAIL_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
      message: e.message,
    });
  }
}
function* watchFetchNotUsersForActivity() {
  yield takeLatest(
    REQUEST_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
    fetchUsersNotForActivity
  );
}

function* deleteUserFromActivity(action) {
  try {
    const response = yield call(api.deleteUserFromActivity, action.payload);
    yield put({ type: SUCCESS_DELETE_USER_FROM_ACTIVITY, response });
    yield call(fetchUsersForActivity, { payload: action.payload.activityId });
    yield call(fetchUsersNotForActivity, {
      payload: action.payload.activityId,
    });
  } catch (e) {
    yield put({
      type: FAIL_DELETE_USER_FROM_ACTIVITY,
      message: e.message,
    });
  }
}
function* watchDeleteUserFromActivity() {
  yield takeLatest(REQUEST_DELETE_USER_FROM_ACTIVITY, deleteUserFromActivity);
}

function* addUserToActivity(action) {
  try {
    const response = yield call(api.addUserToActivity, action.payload);
    yield put({ type: SUCCESS_ADD_USER_TO_ACTIVITY, response });
    yield call(fetchUsersForActivity, { payload: action.payload.activityId });
    yield call(fetchUsersNotForActivity, {
      payload: action.payload.activityId,
    });
  } catch (e) {
    yield put({
      type: FAIL_ADD_USER_TO_ACTIVITY,
      message: e.message,
    });
  }
}
function* watchAddUserToActivity() {
  yield takeLatest(REQUEST_ADD_USER_TO_ACTIVITY, addUserToActivity);
}

function* fetchUserActivitiesData(action) {
  try {
    const response = yield call(api.getUserActivitiesData, action.payload);
    yield put({ type: SUCCESS_GET_USER_ACTIVITIES_DATA, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_USER_ACTIVITIES_DATA,
      message: e.message,
    });
  }
}
function* watchFetchUserActivitiesData() {
  yield takeLatest(REQUEST_GET_USER_ACTIVITIES_DATA, fetchUserActivitiesData);
}

function* getHolidayInfo(action) {
  try {
    const response = yield call(api.getHolidayInfo, action.payload);
    yield put({ type: SUCCESS_GET_HOLIDAY_INFO, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_HOLIDAY_INFO,
      message: e.message,
    });
  }
}
function* watchGetHolidayInfo() {
  yield takeLatest(REQUEST_GET_HOLIDAY_INFO, getHolidayInfo);
}

function* getSelfStats(action) {
  try {
    const response = yield call(api.getSelfStats, action.payload);
    yield put({ type: SUCCESS_GET_SELF_STATS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_SELF_STATS,
      message: e.message,
    });
  }
}
function* watchGetSelfStats() {
  yield takeLatest(REQUEST_GET_SELF_STATS, getSelfStats);
}

function* getAllUsersStats(action) {
  try {
    const response = yield call(api.getAllUsersStats, action.payload);
    yield put({ type: SUCCESS_GET_All_USERS_STATS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_All_USERS_STATS,
      message: e.message,
    });
  }
}
function* watchGetAllUsersStats() {
  yield takeLatest(REQUEST_GET_All_USERS_STATS, getAllUsersStats);
}

function* getSelfClaims(action) {
  try {
    const response = yield call(api.getSelfClaims, action.payload);
    yield put({ type: SUCCESS_GET_SELF_CLAIMS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_SELF_CLAIMS,
      message: e.message,
    });
  }
}
function* watchGetSelfClaims() {
  yield takeLatest(REQUEST_GET_SELF_CLAIMS, getSelfClaims);
}

function* getUserClaims(action) {
  try {
    const response = yield call(api.getUserClaims, action.payload);
    yield put({ type: SUCCESS_GET_USER_CLAIMS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_USER_CLAIMS,
      message: e.message,
    });
  }
}
function* watchGetUserClaims() {
  yield takeLatest(REQUEST_GET_USER_CLAIMS, getUserClaims);
}

function* getStageStats(action) {
  yield put({ type: LOADING_GET_STAGE_STATS });
  try {
    const response = yield call(api.getStageStats, action.payload);
    yield put({ type: SUCCESS_GET_STAGE_STATS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_STAGE_STATS,
      message: e.message,
    });
  }
}
function* watchGetStageStats() {
  yield takeLatest(REQUEST_GET_STAGE_STATS, getStageStats);
}

function* getProjectStats(action) {
  yield put({ type: LOADING_GET_PROJECT_STATS });
  try {
    const response = yield call(api.getProjectStats, action.payload);
    yield put({ type: SUCCESS_GET_PROJECT_STATS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_PROJECT_STATS,
      message: e.message,
    });
  }
}
function* watchGetProjectStats() {
  yield takeLatest(REQUEST_GET_PROJECT_STATS, getProjectStats);
}

function* getActivityStats(action) {
  yield put({ type: LOADING_GET_ACTIVITY_STATS });
  try {
    const response = yield call(api.getActivityStats, action.payload);
    yield put({ type: SUCCESS_GET_ACTIVITY_STATS, response });
  } catch (e) {
    yield put({
      type: FAIL_GET_ACTIVITY_STATS,
      message: e.message,
    });
  }
}
function* watchGetActivityStats() {
  yield takeLatest(REQUEST_GET_ACTIVITY_STATS, getActivityStats);
}

function* rootSaga() {
  yield all([
    watchFetchProjects(),
    watchFetchUsers(),
    watchFetchUsersForStage(),
    watchFetchNotUsersForStage(),
    watchFetchProjectData(),
    watchDeleteUserFromStage(),
    watchDeleteSelfUserFromStage(),
    watchAddUserToStage(),
    watchAddSelfUserToStage(),
    watchFetchUserDataForAdmin(),
    watchFetchUserDataForSelf(),
    watchFetchAuthUserData(),
    watchFetchUserActiveProjectTreeData(),
    watchFetchUserInactiveProjectTreeData(),
    watchFetchGetTimeSheetData(),
    watchFetchGetTimeSheetDataOfUser(),
    watchGetAllIncomeExpense(),
    watchDeleteIncomeExpenseEntry(),
    watchAddIncomeExpenseEntry(),
    watchGetIncomeExpenseBalance(),
    watchGetCalendarData(),
    watchGetAllActivities(),
    watchGetAllActivityData(),
    watchFetchUsersForActivity(),
    watchFetchNotUsersForActivity(),
    watchDeleteUserFromActivity(),
    watchAddUserToActivity(),
    watchFetchUserActivitiesData(),
    watchGetHolidayInfo(),
    watchGetSelfStats(),
    watchGetAllUsersStats(),
    watchGetSelfClaims(),
    watchGetUserClaims(),
    watchGetStageStats(),
    watchGetProjectStats(),
    watchGetActivityStats(),
  ]);
}

export default rootSaga;
